<template>
    <div class="modal-wrap">
        <div class="form">
            <h2>{{ $t('footer.terms') }}</h2>
            <div class="iframe-wrap">
                <iframe
                    id="iframe1"
                    :src="link"
                    frameborder="0"
                    allowfullscreen="allowfullscreen"
                    scrolling="no"
                ></iframe>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        baseUrl () {
            return process.env.VUE_APP_VIDEO_BASE;
        },
        link () {
            return this.baseUrl + '/terms-and-conditions.html'
        },
    },
    mounted () {
        window.addEventListener('keydown', this.handleEvent)
        const iframe = document.getElementById('iframe1');
        iframe.addEventListener('load', () => {
            // this will work only on same origin iframes
            this.resizeIFrameToFitContent(iframe);
        })
    },
    methods: {
        closeModal () {
            window.removeEventListener('keydown', this.handleEvent)
            this.$emit('close-modal')
        },
        handleEvent (e) {
            if (parseInt(e.keyCode) === 27) {
                this.closeModal()
            }
        },
        resizeIFrameToFitContent (iFrame) {
            iFrame.style.height = iFrame.contentWindow.document.documentElement.scrollHeight + 'px';
        }
    },
};
</script>

<style lang="scss" scoped>
.modal-wrap {
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("/background.png") center center / cover;
    .form {
        position: relative;
        width: 80%;
        min-height: 550px;
        max-height: 80vh;
        background-color: #FFF;
        display: flex;
        flex-direction: column;
        overflow: auto;
        padding-bottom: 20px;
        margin-bottom: 100px;
        h2 {
            text-align: center;
            margin: 2em;
            font-size: 16px;
            font-weight: 600;
            font-family: "Roboto";
        }
        .icon-wrap {
            position: sticky;
            top: 10px;
            // right: 10px;
            cursor: pointer;
            text-align: right;
            span {
                margin: 10px;
                margin-top: 0;
            }
        }
        .iframe-wrap {
            position: relative;
            flex-grow: 1;
            padding: 0 3vw 20px 3vw;
            iframe {
                position: absolute; 
                border: none;
                width: calc(100% - 6vw);
            }
        }
    }
}
</style>